export const redirectEmail = (email: string) => {
  const encodedEmail = encodeURIComponent(email);
  const link = `mailto:${encodedEmail}`;
  const a = document.createElement("a");
  a.href = link;
  a.textContent = "Enviar correo";
  document.body.appendChild(a);
  a.click();
};
